import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
  data: null,
};

export const login = createAsyncThunk(
  'user/login',
  async (formData) => {
    try {
      const response = await myAxios.post(`/admin/login`, formData);
      if(response?.data?.status==='success'){
        const authToken = await response?.data?.authUser?.token;
        localStorage.setItem('authToken', authToken);
        localStorage.setItem('authUserData', JSON.stringify(response?.data?.authUser));
        return { success: true, message: "logged in successfully!", data: response?.data?.authUser };
      }else{
        return { success: false, message: response?.data?.message, data: response?.data };
      }
    } catch (error) {
      if (error?.response?.data) {
        return { success: false, message: error?.response?.data?.message };
      } else {
        return { success: false, message: 'Sorry, something went wrong!' };
      }
    }
  },
);
export const changePassword = createAsyncThunk(
  'user/changePassword',
  async (formData) => {
    try {
      const response = await myAxios.put(`/admin/change-password`, formData);
      return { success: true, message: "Password changed successfully!", data: response?.data };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || 'Sorry, something went wrong!',
      };
    }
  },
);
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    clearLoginData: state => {
      state.data = null;
    },
    setLoginData: (state, action) => {
      state.data = action.payload;
    },
    clearChangePasswordData: (state) => {
      state.changePasswordData = null;
    },
    setChangePasswordData: (state, action) => {
      state.changePasswordData = action.payload;
    },
  },
});

export const loginReducer = loginSlice.reducer;
export const { clearLoginData, setLoginData, clearChangePasswordData, setChangePasswordData } = loginSlice.actions;

export const selectLoggedInData = (state) => state.loginUser.data;
export const selectChangePasswordData = (state) => state.user.changePasswordData;
